/* istanbul ignore file */
import React from 'react';
import { useFieldHelper, LinkField, FieldProps } from 'framework/ui/field';
import { usePurchaseOrderUrl } from 'domain/finance/purchaseOrder/shared/usePurchaseOrderRouting';

interface PurchaseOrderLinkProps extends FieldProps {
  nameSource: string;
}

const PurchaseOrderLink = ({ source, nameSource, ...props }: PurchaseOrderLinkProps) => {
  const { getValue } = useFieldHelper({ source });
  const { getValue: getName } = useFieldHelper({ source: nameSource });
  const { getSingleEntityUrl } = usePurchaseOrderUrl();
  const id = getValue();
  const name = getName();

  return id || name ? <LinkField linkText={name || id} isInternal value={getSingleEntityUrl(id)} {...props} /> : null;
};

export default PurchaseOrderLink;
